module.exports = "<span [style.color]=\"showColor ? color : ''\">\n    {{showValue}}\n</span>\n  "